import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { useEnvConfigModelStore } from '@/models/env-config/envConfig';
import { requestPasswordValidator } from '@/services/docs-site-auth/requestPasswordValidator';
import type { DocsSiteVisitType } from '@/shared/constant/DocsIdTypeData';
import type { OnlineType } from '@/shared/constant/OnlineType';
import { Button, Form, Input, Spin } from 'aui';
import { useEffect, useState } from 'react';
import styles from './DocsSiteAuth.module.css';

const PasswordValidator = (props: {
  id: number | string;
  name?: string;
  onlineType: OnlineType;
  projectId: number;
  imgRender: () => JSX.Element;
  subdirectory?: string;
  visitType?: DocsSiteVisitType;
}) => {
  const { id, imgRender, name, projectId, onlineType, subdirectory, visitType } = props;
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const envConfig = useEnvConfigModelStore((x) => x);
  const [passwordProtectedForm] = Form.useForm();

  const verifyPermissions = async (password: string) => {
    const [error] = await requestPasswordValidator(
      { id, password, projectId },
      onlineType,
      envConfig,
      clientI18n,
      visitType,
      subdirectory,
    );
    if (!error) {
      window.location.reload();
    }
  };

  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = ({ password }: { password: string }) => {
    setSubmitting(true);
    verifyPermissions(password);
    setSubmitting(false);
  };

  useEffect(() => {
    const query = window.location.search;
    const queryParams = new URLSearchParams(query);
    const pwd = queryParams.get('pwd');
    if (pwd) {
      passwordProtectedForm.setFieldsValue({ password: pwd });
      handleSubmit({ password: pwd });
    }
  }, []);

  return (
    <div className="flex flex-col items-center justify-center">
      {imgRender()}
      <div className={styles.auth__name}>{name}</div>
      <div className={styles.auth__description}>{clientI18n('onlineShare.needPassword')}</div>
      <div className={styles.auth__input__component}>
        <Spin spinning={submitting}>
          <div className="flex">
            <Form onFinish={handleSubmit} form={passwordProtectedForm} layout="inline">
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: clientI18n('user.login.password.required'),
                  },
                ]}
              >
                <Input.Password
                  placeholder={clientI18n('user.login.password.required.placeholder')}
                  size="large"
                  className={styles.auth__input__component__input}
                />
              </Form.Item>
              <Button type="primary" htmlType="submit" size="large">
                {clientI18n('view')}
              </Button>
            </Form>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default PasswordValidator;
